// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","fontSmall":"_2tLKT1kaqUNKpr3hwnbdQw _2yWngtzq90F2CtpHEzi19P","colorBlackA40":"rgba(14, 19, 24, 0.4)","colorBlackA07":"rgba(14, 19, 24, 0.07)","colorBlackA03":"rgba(14, 19, 24, 0.03)","tagListItem":"_37hiq5X4GHHgXKPTiPkE84 _2tLKT1kaqUNKpr3hwnbdQw _2yWngtzq90F2CtpHEzi19P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/tags/tags.css
// module id = 930
// module chunks = 0